import {timelineContainer} from "../Utils/timelineContainer";
import {Button} from "./Button";

export class LayoutButton extends timelineContainer(Button) {

    constructor(pCallback?: () => void) {
        super(pCallback || (() => {
            // empty
        }));
    }

    public setLayoutTexture(name: string, anchorX: number, anchorY: number): void {
        const texture = PIXI.utils.TextureCache[name.replace(/\.\w+$/, "")];
        if (texture) {
            if (!this._image) {
                this._image = this._visuals.addChild(new PIXI.Sprite());
            }
            this._image.texture = texture;
            this._image.anchor.x = anchorX;
            this._image.anchor.y = anchorY;
            this.hitArea = new PIXI.Rectangle(
                -this._image.width * 0.5,
                -this._image.height * 0.5,
                this._image.width,
                this._image.height);
        }
    }
}
